export default __webpack_public_path__ + "static/media/loader.27a8bb89.svg";